import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { style: {"height":"40px","line-height":"40px"} }
const _hoisted_2 = { class: "pl-4" }
const _hoisted_3 = { style: {"height":"40px","line-height":"40px"} }
const _hoisted_4 = {
  key: 0,
  style: {"font-weight":"bold"}
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { key: 4 }
const _hoisted_9 = { key: 5 }
const _hoisted_10 = { style: {"height":"40px","line-height":"40px"} }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { style: {"height":"40px","line-height":"40px"} }
const _hoisted_13 = { style: {"height":"40px","line-height":"40px"} }
const _hoisted_14 = {
  key: 0,
  style: {"color":"#e1be7a"},
  class: "pb-0"
}
const _hoisted_15 = {
  key: 1,
  style: {"color":"#e1be7a"},
  class: "pb-0"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 5,
  class: "pt-4 mb-2"
}
const _hoisted_18 = {
  key: 6,
  class: "pt-4 mb-2"
}
const _hoisted_19 = {
  key: 7,
  class: "pt-4 mb-2"
}
const _hoisted_20 = {
  key: 0,
  class: "text-center",
  style: {"font-weight":"bold","border-right":"1px solid #dddddd"}
}
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "text-right" }
const _hoisted_23 = { class: "text-right" }
const _hoisted_24 = {
  class: "text-right",
  style: {"font-weight":"bold"}
}
const _hoisted_25 = { class: "text-right" }
const _hoisted_26 = {
  class: "text-right",
  style: {"border-right":"1px solid #dddddd"}
}
const _hoisted_27 = {
  key: 2,
  class: "text-right"
}
const _hoisted_28 = {
  key: 3,
  class: "text-right"
}
const _hoisted_29 = {
  class: "text-right",
  style: {"font-weight":"bold"}
}
const _hoisted_30 = {
  class: "text-right",
  style: {"font-weight":"bold"}
}
const _hoisted_31 = { class: "text-right" }
const _hoisted_32 = {
  class: "text-right",
  style: {"border-right":"1px solid #dddddd"}
}
const _hoisted_33 = {
  class: "text-right",
  style: {"font-weight":"bold"}
}
const _hoisted_34 = { style: {"height":"40px","line-height":"40px"} }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { style: {"height":"40px","line-height":"40px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fill: "",
    class: "pa-0"
  }, {
    default: _withCtx(() => [
      (_ctx.currentAlAcrData && _ctx.step)
        ? (_openBlock(), _createBlock(_component_v_window, {
            key: 0,
            modelValue: _ctx.step,
            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.step) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window_item, { value: "generateDepreciationStep" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "pa-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "d-flex align-center pt-4 pb-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "5" }, {
                            default: _withCtx(() => _cache[32] || (_cache[32] = [
                              _createElementVNode("h3", { style: {"height":"40px","line-height":"40px"} }, "Type", -1)
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "1" }, {
                            default: _withCtx(() => [
                              _createElementVNode("h3", _hoisted_1, [
                                _createElementVNode("template", _hoisted_2, [
                                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                    activator: _withCtx(({ props }) => [
                                      _createVNode(_component_v_icon, _normalizeProps(_guardReactiveProps(props)), {
                                        default: _withCtx(() => _cache[33] || (_cache[33] = [
                                          _createTextVNode(" $oss-help ")
                                        ])),
                                        _: 2
                                      }, 1040)
                                    ]),
                                    default: _withCtx(() => [
                                      _cache[34] || (_cache[34] = _createElementVNode("h4", { class: "mt-2" }, "AMORTISSEMENT LINEAIRE", -1)),
                                      _cache[35] || (_cache[35] = _createElementVNode("p", { class: "mb-1" }, "Il est la norme.", -1)),
                                      _cache[36] || (_cache[36] = _createElementVNode("p", { class: "mb-1" }, " La charge fiscale est repartie de façon régulière sur le nombre d'années choisi. ", -1)),
                                      _cache[37] || (_cache[37] = _createElementVNode("p", { class: "mb-1" }, "A noter :", -1)),
                                      _cache[38] || (_cache[38] = _createElementVNode("ul", null, [
                                        _createElementVNode("li", null, " Le début est égal à la date de mise en service ou d'acquisition. "),
                                        _createElementVNode("li", null, " La première et dernière années sont calculées aux prorata (en jours), selon la date d'achat et/ou de mise en service. "),
                                        _createElementVNode("li", null, " De fait, l'amortissement s'étale sur une année de plus, même si la durée est, jour pour jour, exactement celle choisie. ")
                                      ], -1)),
                                      _cache[39] || (_cache[39] = _createElementVNode("p", { class: "mb-5" }, null, -1)),
                                      _cache[40] || (_cache[40] = _createElementVNode("h4", null, "AMORTISSEMENT DEGRESSIF", -1)),
                                      _cache[41] || (_cache[41] = _createElementVNode("p", { class: "mb-1" }, "Par dérogation fiscale.", -1)),
                                      _cache[42] || (_cache[42] = _createElementVNode("p", { class: "mb-1" }, " Il fait si que la charge fiscale soit plus importante sur les premières années et qu'elle diminue progressivement. ", -1)),
                                      _cache[43] || (_cache[43] = _createElementVNode("p", { class: "mb-1" }, " Il peut s'appliquer, par exemple à un véhicule qui perd rapidement de la valeur, dès l'achat. ", -1)),
                                      _cache[44] || (_cache[44] = _createElementVNode("p", { class: "mb-3" }, "A noter :", -1)),
                                      _cache[45] || (_cache[45] = _createElementVNode("ul", null, [
                                        _createElementVNode("li", null, " Le début est égal au premier jour du mois d'acquisition et/ou de mise en service. "),
                                        _createElementVNode("li", null, " Seule la première année est calculée aux prorata (en mois entiers), selon la date d'achat et/ou de mise en service. "),
                                        _createElementVNode("li", null, " De fait, la première année étant (sauf achat en janvier) incomplète et les suivantes complétes, la durée d'amortissement s'étale, certes, sur le nombre d'années choisi, mais est plus courte en nombre de mois calendriers. ")
                                      ], -1))
                                    ]),
                                    _: 1
                                  })
                                ])
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "6" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select_filled, {
                                type: "text",
                                modelValue: _ctx.depreciationType,
                                "onUpdate:modelValue": [
                                  _cache[0] || (_cache[0] = ($event: any) => ((_ctx.depreciationType) = $event)),
                                  _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeDotAmoType()))
                                ],
                                items: _ctx.depreciationTypes,
                                "hide-details": "auto",
                                density: "compact"
                              }, null, 8, ["modelValue", "items"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "d-flex align-center py-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "6" }, {
                            default: _withCtx(() => _cache[46] || (_cache[46] = [
                              _createElementVNode("h3", { style: {"height":"40px","line-height":"40px"} }, " Compte comptable de l'écriture d'achat ", -1)
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "6" }, {
                            default: _withCtx(() => [
                              (
                                    _ctx.currentAlAcrData.accountableAccount &&
                                    _ctx.currentAlAcrData.accountableAccount.name &&
                                    _ctx.currentAlAcrData.accountableAccount.description
                                )
                                ? (_openBlock(), _createBlock(_component_oss_text_field_filled, {
                                    key: 0,
                                    outlined: "",
                                    dense: "",
                                    modelValue: _ctx.accountableAccountNameAndDescription,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.accountableAccountNameAndDescription) = $event)),
                                    "hide-details": "auto",
                                    disabled: ""
                                  }, null, 8, ["modelValue"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (!_ctx.hideDurationAndStartDate && _ctx.currentAlAcrData.type != 'N/A')
                        ? (_openBlock(), _createBlock(_component_v_row, {
                            key: 0,
                            "no-gutters": "",
                            class: "d-flex align- py-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "5" }, {
                                default: _withCtx(() => _cache[47] || (_cache[47] = [
                                  _createElementVNode("h3", { style: {"height":"40px","line-height":"40px"} }, "Durée en années", -1)
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_v_col, { cols: "1" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("h3", _hoisted_3, [
                                    (
                                        _ctx.currentAlAcrData.yearDuration &&
                                        (_ctx.currentAlAcrData.yearDuration.defaultYearDuration ||
                                            _ctx.currentAlAcrData.yearDuration.minYearDuration ||
                                            _ctx.currentAlAcrData.yearDuration.maxYearDuration)
                                    )
                                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                          key: 0,
                                          location: "bottom"
                                        }, {
                                          activator: _withCtx(({ props }) => [
                                            _createVNode(_component_v_icon, _normalizeProps(_guardReactiveProps(props)), {
                                              default: _withCtx(() => _cache[48] || (_cache[48] = [
                                                _createTextVNode(" $oss-help ")
                                              ])),
                                              _: 2
                                            }, 1040)
                                          ]),
                                          default: _withCtx(() => [
                                            (
                                                _ctx.currentAlAcrData.yearDuration &&
                                                _ctx.currentAlAcrData.yearDuration.defaultYearDuration
                                            )
                                              ? (_openBlock(), _createElementBlock("h3", _hoisted_4, " Durée conseillée par l'administration fiscale : " + _toDisplayString(_ctx.currentAlAcrData.yearDuration.defaultYearDuration), 1))
                                              : (_openBlock(), _createElementBlock("h3", _hoisted_5, _cache[49] || (_cache[49] = [
                                                  _createTextVNode(" Durée conseillée par l'administration fiscale : "),
                                                  _createElementVNode("i", null, "pas renseignée", -1)
                                                ]))),
                                            (
                                                _ctx.currentAlAcrData.yearDuration &&
                                                _ctx.currentAlAcrData.yearDuration.minYearDuration &&
                                                _ctx.currentAlAcrData.yearDuration.minYearDuration > 0
                                            )
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Durée minimale admise : " + _toDisplayString(_ctx.currentAlAcrData.yearDuration.minYearDuration), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_7, _cache[50] || (_cache[50] = [
                                                  _createTextVNode("Durée minimale admise : "),
                                                  _createElementVNode("i", null, "pas renseignée", -1)
                                                ]))),
                                            (
                                                _ctx.currentAlAcrData.yearDuration &&
                                                _ctx.currentAlAcrData.yearDuration.maxYearDuration &&
                                                _ctx.currentAlAcrData.yearDuration.maxYearDuration > 0
                                            )
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Durée maximale admise : " + _toDisplayString(_ctx.currentAlAcrData.yearDuration.maxYearDuration), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_9, _cache[51] || (_cache[51] = [
                                                  _createTextVNode("Durée maximale admise : "),
                                                  _createElementVNode("i", null, "pas renseignée", -1)
                                                ])))
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              }),
                              (!_ctx.hideDurationAndStartDate)
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 0,
                                    cols: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      (_ctx.depreciationType !== 'N/A')
                                        ? (_openBlock(), _createBlock(_component_oss_text_field_filled, {
                                            key: 0,
                                            outlined: "",
                                            dense: "",
                                            "hide-details": "auto",
                                            modelValue: _ctx.currentAlAcrData.selectedYearDuration,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentAlAcrData.selectedYearDuration) = $event)),
                                            rules: [(v) => v > 0 || 'Saisir un chiffre positif']
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.currentAlAcrData.selectedYearDuration), 1)
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue", "rules"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (!_ctx.hideDurationAndStartDate && _ctx.currentAlAcrData.type != 'N/A')
                        ? (_openBlock(), _createBlock(_component_v_row, {
                            key: 1,
                            "no-gutters": "",
                            class: "d-flex align-center py-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "6" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("h3", _hoisted_10, " Date de mise en service (achat : " + _toDisplayString(_ctx.formatDate(_ctx.currentAlAcrData.date)) + ") ", 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, { cols: "6" }, {
                                default: _withCtx(() => [
                                  (_ctx.depreciationType !== 'N/A')
                                    ? (_openBlock(), _createBlock(_component_oss_date_picker_filled, {
                                        key: 0,
                                        modelValue: _ctx.currentAlAcrData.linearSpreadStartDate,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currentAlAcrData.linearSpreadStartDate) = $event)),
                                        style: {"flex":"1"},
                                        textFieldReadOnly: false,
                                        "hide-details": ""
                                      }, null, 8, ["modelValue"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "d-flex align-center py-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "6" }, {
                            default: _withCtx(() => _cache[52] || (_cache[52] = [
                              _createElementVNode("h3", { style: {"height":"40px","line-height":"40px"} }, "Libellé immobilisation", -1)
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "6" }, {
                            default: _withCtx(() => [
                              (
                                    _ctx.currentAlAcrData.fixedAssetWording &&
                                    _ctx.currentAlAcrData.fixedAssetWording.startsWith(
                                        'Reprise immos + amos 20',
                                    )
                                )
                                ? (_openBlock(), _createElementBlock("h3", _hoisted_11, _toDisplayString(_ctx.currentAlAcrData.fixedAssetWording), 1))
                                : (_openBlock(), _createBlock(_component_v_text_field_filled, {
                                    key: 1,
                                    outlined: "",
                                    modelValue: _ctx.currentAlAcrData.fixedAssetWording,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.currentAlAcrData.fixedAssetWording) = $event)),
                                    type: "text",
                                    "hide-details": "auto",
                                    density: "compact"
                                  }, null, 8, ["modelValue"]))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (
                            _ctx.currentAlAcrData.globalNetAmountSigned &&
                            _ctx.currentAlAcrData.globalNetAmountSigned !=
                                _ctx.currentAlAcrData.amountSigned &&
                            _ctx.currentAlAcrData.globalVatAmountSigned
                        )
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createVNode(_component_v_divider, { class: "mt-6" }),
                            _createVNode(_component_v_row, {
                              "no-gutters": "",
                              class: "d-flex align-center pt-2 pb-0"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => _cache[53] || (_cache[53] = [
                                    _createElementVNode("h3", { style: {"height":"40px","line-height":"40px"} }, " Total HT de la facture différent du montant de l'immobilisation : vérifier et corrigez le montant de la TVA ", -1)
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, {
                              "no-gutters": "",
                              class: "d-flex align-center py-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "6" }, {
                                  default: _withCtx(() => _cache[54] || (_cache[54] = [
                                    _createTextVNode(" Totaux de la facture : ")
                                  ])),
                                  _: 1
                                }),
                                (_ctx.currentAlAcrData.globalNetAmountSigned !== 0)
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 0,
                                      cols: "3",
                                      class: "pr-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_oss_text_field_filled, {
                                          outlined: "",
                                          dense: "",
                                          label: "HT total",
                                          disabled: "",
                                          "hide-details": "auto",
                                          modelValue: _ctx.currentAlAcrData.globalNetAmountSigned,
                                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.currentAlAcrData.globalNetAmountSigned) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.currentAlAcrData.globalVatAmountSigned !== 0)
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 1,
                                      cols: "3",
                                      class: "pl-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_oss_text_field_filled, {
                                          outlined: "",
                                          dense: "",
                                          label: "TVA totale",
                                          disabled: "",
                                          "hide-details": "auto",
                                          modelValue: _ctx.currentAlAcrData.globalVatAmountSigned,
                                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.currentAlAcrData.globalVatAmountSigned) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, {
                              "no-gutters": "",
                              class: "d-flex align-center py-2"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.currentAlAcrData.globalNetAmountSigned !== 0)
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 0,
                                      cols: "6"
                                    }, {
                                      default: _withCtx(() => [
                                        _cache[55] || (_cache[55] = _createTextVNode(" Dont cette immobilisation ")),
                                        _createVNode(_component_v_btn_icon, {
                                          icon: "$remove_red_eye",
                                          onClick: _cache[8] || (_cache[8] = ($event: any) => (
                                        _ctx.openObject(
                                            _ctx.currentAlAcrData.documentId,
                                            _ctx.currentAlAcrData.objectType,
                                        )
                                    )),
                                          size: "x-small"
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.currentAlAcrData.amountSigned !== 0)
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 1,
                                      cols: "3",
                                      class: "pr-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_oss_text_field_filled, {
                                          outlined: "",
                                          dense: "",
                                          "hide-details": "auto",
                                          label: "Prix d'achat HT",
                                          disabled: "",
                                          modelValue: _ctx.currentAlAcrData.amountSigned,
                                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.currentAlAcrData.amountSigned) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_col, { cols: "3" })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, {
                              "no-gutters": "",
                              class: "d-flex align-center pt-2 pb-4"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.currentAlAcrData.netAmountOriginalValue !== 0)
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 0,
                                      cols: "6"
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.currentAlAcrData.netAmountOriginalValue !== 0)
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 1,
                                      cols: "3",
                                      class: "pr-1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_oss_text_field_filled, {
                                          "hide-details": "auto",
                                          label: "Base amortissable HT",
                                          modelValue: _ctx.currentAlAcrData.depreciableAmountSigned,
                                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.currentAlAcrData.depreciableAmountSigned) = $event)),
                                          rules: _ctx.minMaxRules(_ctx.currentAlAcrData.netAmountOriginalValue)
                                        }, null, 8, ["modelValue", "rules"])
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_col, {
                                  cols: "3",
                                  class: "pl-1"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_oss_text_field_filled, {
                                      modelValue: _ctx.currentAlAcrData.alVatAmountSigned,
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.currentAlAcrData.alVatAmountSigned) = $event)),
                                      rules: _ctx.minMaxRules(_ctx.currentAlAcrData.globalVatAmountSigned),
                                      hint: "Définir la TVA à reporter dans le tableau d'immos",
                                      "hide-details": "auto",
                                      label: "TVA déd. (au prorata du prix total)"
                                    }, null, 8, ["modelValue", "rules"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _createVNode(_component_v_row, {
                              "no-gutters": "",
                              class: "d-flex align-center py-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "6" }, {
                                  default: _withCtx(() => _cache[56] || (_cache[56] = [
                                    _createElementVNode("h3", { style: {"height":"40px","line-height":"40px"} }, " Valeur d'achat HT de l'immobilisation ", -1)
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "6" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_oss_text_field_filled, {
                                      "content-class": "mt-3 v-text-field oss-input",
                                      "hide-details": "auto",
                                      readonly: "",
                                      disabled: "",
                                      modelValue: _ctx.currentAlAcrData.amountSigned,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.currentAlAcrData.amountSigned) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (!_ctx.hideDurationAndStartDate && _ctx.currentAlAcrData.type != 'N/A')
                              ? (_openBlock(), _createBlock(_component_v_row, {
                                  key: 0,
                                  "no-gutters": "",
                                  class: "d-flex align-center py-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "6" }, {
                                      default: _withCtx(() => _cache[57] || (_cache[57] = [
                                        _createElementVNode("h3", { style: {"height":"40px","line-height":"40px"} }, " Base amortissable HT (si différente) ", -1)
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, { cols: "6" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_oss_text_field_filled, {
                                          "content-class": "mt-3 v-text-field oss-input",
                                          "hide-details": "auto",
                                          modelValue: _ctx.currentAlAcrData.depreciableAmountSigned,
                                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.currentAlAcrData.depreciableAmountSigned) = $event)),
                                          rules: [
                                        (v) => v > 0 || '> 0',
                                        (v) =>
                                            v <= _ctx.currentAlAcrData.amountSigned ||
                                            `> à la valeur d'achat`,
                                    ]
                                        }, null, 8, ["modelValue", "rules"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (!_ctx.hideDurationAndStartDate)
                              ? (_openBlock(), _createBlock(_component_v_row, {
                                  key: 1,
                                  "no-gutters": "",
                                  class: "d-flex align-center pb-4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "6" }, {
                                      default: _withCtx(() => _cache[58] || (_cache[58] = [
                                        _createElementVNode("h3", { style: {"height":"40px","line-height":"40px"} }, "TVA", -1)
                                      ])),
                                      _: 1
                                    }),
                                    (_ctx.currentAlAcrData.alVatAmountSigned)
                                      ? (_openBlock(), _createBlock(_component_v_col, {
                                          key: 0,
                                          cols: "6"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_oss_text_field_filled, {
                                              "content-class": "mt-3 v-text-field oss-input",
                                              "hide-details": "auto",
                                              modelValue: _ctx.currentAlAcrData.alVatAmountSigned,
                                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.currentAlAcrData.alVatAmountSigned) = $event))
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        }))
                                      : (_openBlock(), _createBlock(_component_v_col, { key: 1 }, {
                                          default: _withCtx(() => _cache[59] || (_cache[59] = [
                                            _createElementVNode("h3", { style: {"height":"40px","line-height":"40px"} }, "Pas de TVA", -1)
                                          ])),
                                          _: 1
                                        }))
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ], 64))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_card_actions, { style: {"padding-right":"24px","padding-left":"24px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        rounded: "",
                        class: "ma-2",
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('quitDepreciationTableDialog'))),
                        color: 'secondary'
                      }, {
                        default: _withCtx(() => _cache[60] || (_cache[60] = [
                          _createTextVNode(" Annuler ")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_btn, {
                        disabled: _ctx.disabledNextBtn(_ctx.currentAlAcrData),
                        rounded: "",
                        class: "ma-2",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.generateLocalSpreadFromServices(_ctx.currentAlAcrData))),
                        color: 'primary',
                        "data-cy": "CheckFixedAssetsDepreciationTable-nextCreation"
                      }, {
                        default: _withCtx(() => _cache[61] || (_cache[61] = [
                          _createTextVNode(" Suivant ")
                        ])),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: "outflowStep" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "py-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "d-flex align-center py-4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "6" }, {
                            default: _withCtx(() => [
                              _createElementVNode("h3", _hoisted_12, " Date de sortie d'immo (mise en service : " + _toDisplayString(_ctx.formatDate(_ctx.currentAlAcrData.linearSpreadStartDate)) + ") ", 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "6" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_oss_date_picker_filled, {
                                modelValue: _ctx.currentAlAcrData.outflowDate,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.currentAlAcrData.outflowDate) = $event)),
                                style: {"flex":"1"},
                                textFieldReadOnly: false,
                                hint: `Première date comptable ouverte : ${_ctx.formatDate(
                                    _ctx.outflowMinDate,
                                )}`,
                                minDate: _ctx.outflowMinDate,
                                "data-cy": "CheckFixedAssetsDepreciationTable-dateSortie"
                              }, null, 8, ["modelValue", "hint", "minDate"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "d-flex align-center pb-4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "6" }, {
                            default: _withCtx(() => [
                              _createElementVNode("h3", _hoisted_13, " Prix de cession (base amortissable : " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                        _ctx.currentAlAcrData.depreciableAmountSigned,
                                        undefined,
                                    )) + ") ", 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "6" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_oss_text_field_filled, {
                                "content-class": "mt-3 v-text-field oss-input",
                                modelValue: _ctx.currentAlAcrData.sellAmount,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.currentAlAcrData.sellAmount) = $event)),
                                rules: [(v) => {
                                    const num = parseFloat((v + '').replace(',', '.'));
                                    return !isNaN(num) && num >= 0 || 'Valeur négative';
                                    }],
                                "hide-details": "auto"
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_ctx.showOutflowVAT)
                        ? (_openBlock(), _createBlock(_component_v_row, {
                            key: 0,
                            "no-gutters": "",
                            class: "d-flex align-center pb-4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "6" }, {
                                default: _withCtx(() => _cache[62] || (_cache[62] = [
                                  _createElementVNode("h3", { style: {"height":"40px","line-height":"40px"} }, "Taux de TVA", -1)
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_v_col, { cols: "6" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_select_filled, {
                                    items: _ctx.vatList,
                                    modelValue: _ctx.currentAlAcrData.sellVatRate,
                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.currentAlAcrData.sellVatRate) = $event)),
                                    "item-value": "value",
                                    "item-title": (item) => item.text,
                                    regular: "",
                                    "hide-details": true,
                                    outlined: "",
                                    density: "compact"
                                  }, null, 8, ["items", "modelValue", "item-title"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_card_actions, { style: {"padding-right":"24px","padding-left":"24px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        rounded: "",
                        class: "ma-2",
                        onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.$emit('quitDepreciationTableDialog'))),
                        color: 'secondary'
                      }, {
                        default: _withCtx(() => _cache[63] || (_cache[63] = [
                          _createTextVNode(" Annuler ")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_btn, {
                        disabled: _ctx.disabledOutflowNextBtn(_ctx.currentAlAcrData),
                        rounded: "",
                        class: "ma-2",
                        color: "primary",
                        "data-cy": "CheckFixedAssetsDepreciationTable-nextSortie",
                        onClick: _cache[21] || (_cache[21] = ($event: any) => {
                            _ctx.step = 'tableStep';
                            _ctx.generateOutflowLocalSpread(_ctx.currentAlAcrData);
                        })
                      }, {
                        default: _withCtx(() => _cache[64] || (_cache[64] = [
                          _createTextVNode(" Suivant ")
                        ])),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, {
                value: "tableStep",
                class: "justify-space-around"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "pa-0" }, {
                    default: _withCtx(() => [
                      (
                            !_ctx.onlyShowTable &&
                            !_ctx.currentAlAcrData.outflowDate &&
                            _ctx.currentAlAcrData.type &&
                            _ctx.currentAlAcrData.type !== 'N/A'
                        )
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_ctx.firstUnclosedPeriod)
                              ? (_openBlock(), _createElementBlock("h3", _hoisted_14, " PREALABLE : toutes les périodes clôturées doivent être renseignées dans \"Mon dossier - Exercices\" "))
                              : _createCommentVNode("", true),
                            _cache[65] || (_cache[65] = _createElementVNode("h3", {
                              style: {"color":"#e1be7a"},
                              class: "pb-0"
                            }, " Le tableau est construit en totalité ", -1)),
                            _cache[66] || (_cache[66] = _createElementVNode("h3", {
                              style: {"color":"#e1be7a"},
                              class: "pb-0"
                            }, " Les écritures de dotation aux amortissements seront générées : ", -1)),
                            (
                                _ctx.firstUnclosedPeriod &&
                                _ctx.firstUnclosedPeriod.id &&
                                _ctx.accountingPeriod.id !== _ctx.firstUnclosedPeriod.id
                            )
                              ? (_openBlock(), _createElementBlock("h3", _hoisted_15, " - seulement en partant du " + _toDisplayString(_ctx.formatDate(_ctx.firstUnclosedPeriod.start)) + ", les périodes précédantes étant clôturées. ", 1))
                              : _createCommentVNode("", true),
                            _cache[67] || (_cache[67] = _createElementVNode("h3", {
                              style: {"color":"#e1be7a"},
                              class: "pb-4"
                            }, " - mensuellement, pour tous les exercices restant à courir. ", -1))
                          ], 64))
                        : _createCommentVNode("", true),
                      (
                            _ctx.currentAlAcrData.outflowDate &&
                            _ctx.currentAlAcrData.depreciationTable &&
                            _ctx.currentAlAcrData.depreciationTable.length
                        )
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _cache[68] || (_cache[68] = _createElementVNode("h3", {
                              style: {"color":"#e1be7a"},
                              class: "pb-0"
                            }, " Les dotations aux amortissements postérieures à la date de sortie sont supprimées. ", -1)),
                            _cache[69] || (_cache[69] = _createElementVNode("h3", {
                              style: {"color":"#e1be7a"},
                              class: "pb-0"
                            }, " En cas de sortie en milieu de mois, une écriture au prorata est générée. ", -1))
                          ], 64))
                        : _createCommentVNode("", true),
                      (_ctx.currentAlAcrData.outflowDate)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _cache[70] || (_cache[70] = _createElementVNode("h3", {
                              style: {"color":"#e1be7a"},
                              class: "pb-0"
                            }, " L'écriture de sortie d'immo est générée, avec la reprise d'amortissement linéaire + dérogatoire. ", -1)),
                            _cache[71] || (_cache[71] = _createElementVNode("h3", {
                              style: {"color":"#e1be7a"},
                              class: "pb-4"
                            }, " L'écriture de cession d'immo n'est pas générée : risque de doublon avec la facture de vente. ", -1))
                          ], 64))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "pb-2"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.accountableAccountNameAndDescription)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "auto"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" c/" + _toDisplayString(_ctx.accountableAccountNameAndDescription), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "py-2"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.currentAlAcrData.amountSigned)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "3"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Valeur du bien H.T. : " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                    Math.abs(_ctx.currentAlAcrData.amountSigned),
                                    undefined,
                                )), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.currentAlAcrData != 'N/A')
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 1,
                                cols: "2"
                              }))
                            : (
                                _ctx.currentAlAcrData.depreciableAmountSigned &&
                                !_ctx.hideDurationAndStartDate &&
                                _ctx.currentAlAcrData != 'N/A'
                            )
                              ? (_openBlock(), _createBlock(_component_v_col, {
                                  key: 2,
                                  cols: "3"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Base amortissable H.T. : " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                    Math.abs(_ctx.currentAlAcrData.depreciableAmountSigned),
                                    undefined,
                                )), 1)
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_v_col, {
                                  key: 3,
                                  cols: "3"
                                })),
                          (_ctx.currentAlAcrData.date)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 4,
                                cols: "3"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Date d'acquisition : " + _toDisplayString(_ctx.formatDate(_ctx.currentAlAcrData.date)), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (
                                _ctx.currentAlAcrData.linearSpreadStartDate && !_ctx.hideDurationAndStartDate
                            )
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 5,
                                cols: "3"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Date de mise en service : " + _toDisplayString(_ctx.formatDate(_ctx.currentAlAcrData.linearSpreadStartDate)), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "pb-2"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.currentAlAcrData.selectedYearDuration)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "3"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Durée : " + _toDisplayString(_ctx.currentAlAcrData.selectedYearDuration) + " ans ", 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.currentAlAcrData.selectedYearDuration)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 1,
                                cols: "3"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Type : L " + _toDisplayString(_ctx.mathFix(100 / _ctx.currentAlAcrData.selectedYearDuration)) + " % ", 1),
                                  (_ctx.currentAlAcrData.rateDeclining)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, " - D " + _toDisplayString(_ctx.mathFix(_ctx.currentAlAcrData.rateDeclining)) + " % ", 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_v_col, {
                                key: 2,
                                cols: "3"
                              })),
                          (
                                _ctx.currentAlAcrData.linearSpreadStartDate &&
                                _ctx.currentAlAcrData.linearSpreadEndDate
                            )
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 3,
                                cols: "3"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" L du " + _toDisplayString(_ctx.formatDate(_ctx.currentAlAcrData.linearSpreadStartDate)) + " au " + _toDisplayString(_ctx.formatDate(_ctx.currentAlAcrData.linearSpreadEndDate)), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (
                                _ctx.currentAlAcrData.decliningSpreadStartDate &&
                                _ctx.currentAlAcrData.decliningSpreadEndDate
                            )
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 4,
                                cols: "3"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" D du " + _toDisplayString(_ctx.formatDate(_ctx.currentAlAcrData.decliningSpreadStartDate)) + " au " + _toDisplayString(_ctx.formatDate(_ctx.currentAlAcrData.decliningSpreadEndDate)), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      (
                            _ctx.currentAlAcrData.type != 'N/A' &&
                            _ctx.companyFirstPeriod &&
                            _ctx.companyFirstPeriod.start &&
                            _ctx.companyFirstPeriod.end &&
                            !_ctx.hideDurationAndStartDate
                        )
                        ? (_openBlock(), _createBlock(_component_v_row, {
                            key: 3,
                            "no-gutters": "",
                            class: "pb-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Premier exercice : du " + _toDisplayString(_ctx.formatDate(_ctx.companyFirstPeriod.start)) + " au " + _toDisplayString(_ctx.formatDate(_ctx.companyFirstPeriod.end)), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.currentAlAcrData.outflowDate)
                        ? (_openBlock(), _createBlock(_component_v_row, {
                            key: 4,
                            "no-gutters": ""
                          }, {
                            default: _withCtx(() => [
                              (_ctx.currentAlAcrData.sellAmount)
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 0,
                                    cols: "3"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Sortie : " + _toDisplayString(_ctx.formatDate(_ctx.currentAlAcrData.outflowDate)) + " - Prix cession : " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.currentAlAcrData.sellAmount, undefined)), 1)
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createBlock(_component_v_col, {
                                    key: 1,
                                    class: "pb-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Sortie : " + _toDisplayString(_ctx.formatDate(_ctx.currentAlAcrData.outflowDate)) + " - Mise au rebut ", 1)
                                    ]),
                                    _: 1
                                  })),
                              (_ctx.currentAlAcrData.moreOrLessValue > 0)
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 2,
                                    cols: "3"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Moins-value : " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.currentAlAcrData.moreOrLessValue, undefined)), 1)
                                    ]),
                                    _: 1
                                  }))
                                : (_ctx.currentAlAcrData.moreOrLessValue < 0)
                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                      key: 3,
                                      class: "pb-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Plus-value : " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                    Math.abs(_ctx.currentAlAcrData.moreOrLessValue),
                                    undefined,
                                )), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_v_col, {
                                      key: 4,
                                      class: "pb-2"
                                    }, {
                                      default: _withCtx(() => _cache[72] || (_cache[72] = [
                                        _createTextVNode(" +/- value : - ")
                                      ])),
                                      _: 1
                                    })),
                              (_ctx.reversal28)
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 5,
                                    cols: "3"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Reprise amo L : " + _toDisplayString(_ctx.newCommonFormatCurrency(-_ctx.reversal28, undefined)), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.reversal145)
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 6,
                                    cols: "3"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Reprise amo dérog : " + _toDisplayString(_ctx.newCommonFormatCurrency(-_ctx.reversal145, undefined)), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.currentAlAcrData.type && _ctx.currentAlAcrData.type === 'N/A')
                        ? (_openBlock(), _createElementBlock("h2", _hoisted_17, " Non amortissable "))
                        : (_ctx.currentAlAcrData.linearDepreciation)
                          ? (_openBlock(), _createElementBlock("h2", _hoisted_18, " Tableau d'amortissement linéaire "))
                          : (_openBlock(), _createElementBlock("h2", _hoisted_19, "Tableau d'amortissement dégressif")),
                      (
                            _ctx.currentAlAcrData.depreciationTable &&
                            _ctx.currentAlAcrData.depreciationTable.length
                        )
                        ? (_openBlock(), _createBlock(_component_v_data_table, {
                            key: 8,
                            headers: _ctx.depreciationHeaders,
                            items: _ctx.currentAlAcrData.depreciationTable,
                            loading: _ctx.loading,
                            class: "table",
                            style: {"border":"1px #ededed solid"},
                            "items-per-page": -1,
                            "fixed-header": "",
                            height: _ctx.dataTableHeight
                          }, {
                            "no-data": _withCtx(() => _cache[73] || (_cache[73] = [
                              _createTextVNode("Pas d'amortissements")
                            ])),
                            item: _withCtx((props) => [
                              _createElementVNode("tr", null, [
                                (props.item.resumePeriodEnd)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_20, _toDisplayString(_ctx.formatDate(props.item.resumePeriodEnd)), 1))
                                  : (_openBlock(), _createElementBlock("td", _hoisted_21)),
                                _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.newCommonFormatCurrency(
                                            props.item.linearNetBookValue0101,
                                            undefined,
                                        )), 1),
                                _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.newCommonFormatCurrency(
                                            props.item.linearAccumulatedDepreciationStart,
                                            undefined,
                                        )), 1),
                                _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.newCommonFormatCurrency(
                                            props.item.linearYearDepreciation,
                                            undefined,
                                        )), 1),
                                _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.newCommonFormatCurrency(
                                            props.item.linearAccumulatedDepreciation,
                                            undefined,
                                        )), 1),
                                _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.newCommonFormatCurrency(
                                            props.item.linearNetBookValue3112,
                                            undefined,
                                        )), 1),
                                (
                                        _ctx.currentAlAcrData.type === 'Dégressif' ||
                                        _ctx.currentAlAcrData.type === 'D'
                                    )
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_27, _toDisplayString(_ctx.newCommonFormatCurrency(
                                            props.item.decliningNetBookValue0101,
                                            undefined,
                                        )), 1))
                                  : (_openBlock(), _createElementBlock("td", _hoisted_28, "-")),
                                _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.newCommonFormatCurrency(
                                            props.item.decliningAccumulatedDepreciationStart,
                                            undefined,
                                        )), 1),
                                _createElementVNode("td", _hoisted_30, _toDisplayString(_ctx.newCommonFormatCurrency(
                                            props.item.decliningYearDepreciation,
                                            undefined,
                                        )), 1),
                                _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.newCommonFormatCurrency(
                                            props.item.decliningAccumulatedDepreciation,
                                            undefined,
                                        )), 1),
                                _createElementVNode("td", _hoisted_32, _toDisplayString(_ctx.newCommonFormatCurrency(
                                            props.item.decliningNetBookValue3112,
                                            undefined,
                                        )), 1),
                                _createElementVNode("td", _hoisted_33, _toDisplayString(_ctx.newCommonFormatCurrency(
                                            props.item.derogationYearDepreciation,
                                            undefined,
                                        )), 1)
                              ])
                            ]),
                            _: 1
                          }, 8, ["headers", "items", "loading", "height"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_card_actions, { style: {"padding-right":"24px","padding-left":"24px"} }, {
                    default: _withCtx(() => [
                      (!_ctx.onlyShowTable && _ctx.generateDepreciation)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            rounded: "",
                            class: "ma-2",
                            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.step = 'generateDepreciationStep')),
                            color: 'secondary'
                          }, {
                            default: _withCtx(() => _cache[74] || (_cache[74] = [
                              _createTextVNode(" Retour ")
                            ])),
                            _: 1
                          }))
                        : (!_ctx.onlyShowTable)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 1,
                              rounded: "",
                              class: "ma-2",
                              onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.step = 'outflowStep')),
                              color: 'secondary'
                            }, {
                              default: _withCtx(() => _cache[75] || (_cache[75] = [
                                _createTextVNode(" Retour ")
                              ])),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                      _createVNode(_component_v_spacer),
                      (_ctx.onlyShowTable)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 2,
                            onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.$emit('quitDepreciationTableDialog')))
                          }, {
                            default: _withCtx(() => _cache[76] || (_cache[76] = [
                              _createTextVNode(" Fermer ")
                            ])),
                            _: 1
                          }))
                        : (_ctx.generateDepreciation)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 3,
                              onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.validateDepreciation())),
                              color: 'primary',
                              "data-cy": "CheckFixedAssetsDepreciationTable-validCreation"
                            }, {
                              default: _withCtx(() => _cache[77] || (_cache[77] = [
                                _createTextVNode(" Générer ")
                              ])),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_v_btn, {
                              key: 4,
                              rounded: "",
                              class: "ma-2",
                              onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.validateFixedAssetOutflow())),
                              color: 'primary',
                              "data-cy": "CheckFixedAssetsDepreciationTable-validSortie"
                            }, {
                              default: _withCtx(() => _cache[78] || (_cache[78] = [
                                _createTextVNode(" Générer ")
                              ])),
                              _: 1
                            }))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: "setTypeNaOnClosedPeriod" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "py-0" }, {
                    default: _withCtx(() => [
                      _cache[83] || (_cache[83] = _createElementVNode("h2", { class: "py-2 yellow_custom--text" }, " La \"Reprise d'immobilisations et amortissements sur exercices antérieurs\" a déjà été effectuée, ", -1)),
                      _cache[84] || (_cache[84] = _createElementVNode("h3", { class: "pb-2 yellow_custom--text" }, [
                        _createTextVNode(" mais cette immobilisation, "),
                        _createElementVNode("u", null, "incorporelle où financière"),
                        _createTextVNode(", placée dans une "),
                        _createElementVNode("u", null, "période clôturée"),
                        _createTextVNode(", n'a pas été initialisée. ")
                      ], -1)),
                      _cache[85] || (_cache[85] = _createElementVNode("h3", { class: "pb-2 yellow_custom--text" }, [
                        _createTextVNode(" Les seules actions "),
                        _createElementVNode("u", null, "requises"),
                        _createTextVNode(" et "),
                        _createElementVNode("u", null, "permises"),
                        _createTextVNode(", afin de ne pas modifier les balances et les grand-livres des périodes clôturées, sont ")
                      ], -1)),
                      _cache[86] || (_cache[86] = _createElementVNode("h3", { class: "pl-4 pb-2 yellow_custom--text" }, " - la définir en tant que non amortissable (N/A) ", -1)),
                      _cache[87] || (_cache[87] = _createElementVNode("h3", { class: "pl-4 pb-2 yellow_custom--text" }, " - changer le libellé (si pas généré par la reprise) ", -1)),
                      _cache[88] || (_cache[88] = _createElementVNode("h3", { class: "pl-4 pb-8 yellow_custom--text" }, " - éventuellement, modifier le montant de la TVA afférente ", -1)),
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          (_ctx.accountableAccountNameAndDescription)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "auto"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("h3", _hoisted_34, " c/" + _toDisplayString(_ctx.accountableAccountNameAndDescription), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "d-flex align-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "6" }, {
                            default: _withCtx(() => _cache[79] || (_cache[79] = [
                              _createElementVNode("h3", { style: {"height":"40px","line-height":"40px"} }, "Libellé immobilisation", -1)
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "6" }, {
                            default: _withCtx(() => [
                              (
                                    _ctx.currentAlAcrData.fixedAssetWording &&
                                    _ctx.currentAlAcrData.fixedAssetWording.startsWith(
                                        'Reprise immos + amos 20',
                                    )
                                )
                                ? (_openBlock(), _createElementBlock("h3", _hoisted_35, _toDisplayString(_ctx.currentAlAcrData.fixedAssetWording), 1))
                                : (_openBlock(), _createBlock(_component_v_text_field_filled, {
                                    key: 1,
                                    outlined: "",
                                    modelValue: _ctx.currentAlAcrData.fixedAssetWording,
                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.currentAlAcrData.fixedAssetWording) = $event)),
                                    type: "text",
                                    "hide-details": "auto",
                                    density: "compact"
                                  }, null, 8, ["modelValue"]))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        class: "d-flex align-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "6" }, {
                            default: _withCtx(() => _cache[80] || (_cache[80] = [
                              _createElementVNode("h3", { style: {"height":"40px","line-height":"40px"} }, " Valeur d'achat HT de l'immobilisation ", -1)
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "6" }, {
                            default: _withCtx(() => [
                              _createElementVNode("h3", _hoisted_36, _toDisplayString(_ctx.currentAlAcrData.amountSigned), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (!_ctx.hideDurationAndStartDate)
                        ? (_openBlock(), _createBlock(_component_v_row, {
                            key: 0,
                            "no-gutters": "",
                            class: "d-flex align-center pb-4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "6" }, {
                                default: _withCtx(() => _cache[81] || (_cache[81] = [
                                  _createElementVNode("h3", { style: {"height":"40px","line-height":"40px"} }, "TVA", -1)
                                ])),
                                _: 1
                              }),
                              (_ctx.currentAlAcrData.alVatAmountSigned)
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 0,
                                    cols: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_oss_text_field_filled, {
                                        "content-class": "mt-3 v-text-field oss-input",
                                        "hide-details": "auto",
                                        modelValue: _ctx.currentAlAcrData.alVatAmountSigned,
                                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.currentAlAcrData.alVatAmountSigned) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createBlock(_component_v_col, { key: 1 }, {
                                    default: _withCtx(() => _cache[82] || (_cache[82] = [
                                      _createElementVNode("h3", { style: {"height":"40px","line-height":"40px"} }, "Pas de TVA", -1)
                                    ])),
                                    _: 1
                                  }))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_card_actions, { style: {"padding-right":"24px","padding-left":"24px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        rounded: "",
                        class: "ma-2",
                        onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.$emit('quitDepreciationTableDialog'))),
                        color: 'secondary'
                      }, {
                        default: _withCtx(() => _cache[89] || (_cache[89] = [
                          _createTextVNode(" Annuler ")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_btn, {
                        rounded: "",
                        class: "ma-2",
                        onClick: _cache[30] || (_cache[30] = ($event: any) => {
                            _ctx.currentAlAcrData.type = 'N/A';
                            _ctx.generateLocalSpreadFromServices(_ctx.currentAlAcrData);
                        }),
                        color: 'primary',
                        "data-cy": "CheckFixedAssetsDepreciationTable-nextCreation"
                      }, {
                        default: _withCtx(() => _cache[90] || (_cache[90] = [
                          _createTextVNode(" Suivant ")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}